import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { DATA_INJECTION_TOKEN } from 'src/app/@shared/services/overlay/overlay.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import {
  ROUTE_PLANNING,
  SHARE,
  STATIONS_LIST,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { SearchStopForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/search-stop-form';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { SearchStationDetailedResultComponent } from '../search-station-detailed-result/search-station-detailed-result.component';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';

@Component({
    selector: 'app-search-stations-result-list',
    templateUrl: './search-stations-result-list.component.html',
    styleUrls: ['./search-stations-result-list.component.scss'],
    standalone: false
})
export class StationsResultListComponent implements OnInit{
  @Input() stations: StopFullData[];
  @Output() closeStationListEvent: EventEmitter<void> = new EventEmitter<void>()
  @Output() CloseWithReSubmitEvent: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    @Inject(DATA_INJECTION_TOKEN)
    public readonly data: {
      formValues: SearchStopForm;
    },
    public readonly routePlanningService: RoutePlanningService,
    private readonly queryParamsService: QueryParamsService,
    private readonly languageService: LanguageService
  ) {}

  direction: Direction;

  /** a11y: localized accessible name for the <ul> wrapping the station cards. */
  stationsListAriaLabel: string = '';

  ngOnInit(): void {
    const queryParams = this.queryParamsService.currentParams;
    const poiSelectedIndex = queryParams['poiSelectedIndex']
    if(poiSelectedIndex) {
      setTimeout(() => {
        this.pickStation(this.stations[poiSelectedIndex])
      }, 500)
    }
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.stationsListAriaLabel = STATIONS_LIST[language.language];
      if(this.direction) {
        this.CloseWithReSubmitEvent.emit()
        return;
      }
      this.direction = language.direction
    })
  }

  pickStation(station: StopFullData) {
    // Find the index of the selected station
    const selectedIndex = this.stations.findIndex(
      (s) => s.stopcode === station.stopcode
    );

    // Add the selected index to query params if found
    if (selectedIndex !== -1) {
      this.queryParamsService.setQueryParam('poiSelectedIndex', selectedIndex);
    }

    this.routePlanningService._resultSubject.next({
      type: 'selected',
      value: station,
    });
    this.routePlanningService._componentOverlaySub.next({
      componentType: SearchStationDetailedResultComponent,
      data: {
        stop: station,
        formValues: this.data.formValues,
        closeCallbackFn: (closeData: {closeStationsList: boolean, isLanguageDirectionChanged: boolean}) => {
          if(closeData.closeStationsList) {
            this.closeStationListEvent.emit()
          }
          if(closeData.isLanguageDirectionChanged) {
            this.CloseWithReSubmitEvent.emit()
          }
        }
      },
    });
  }
}
